/**
 * Shape helpers for the `sellMyCar` wizard fields.
 *
 * The store is persisted, and `CAR_DATA_UPDATE_STEPS` (opening a saved
 * evaluation) writes raw API values into the same keys the valuation wizard
 * expects as `{ isSelected, current: { id, title } }`. Normalising on read
 * keeps a stale/legacy shape from breaking a new valuation.
 */

const EMPTY_CHOICE = {
  fetching: false,
  data: [],
  isSelected: false,
  current: {},
};

export function normalizeChoiceField(value) {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    const current =
      value.current && typeof value.current === "object" ? value.current : {};
    return { ...EMPTY_CHOICE, ...value, current };
  }

  const title = value == null || value === "" ? "" : String(value);
  return {
    ...EMPTY_CHOICE,
    isSelected: Boolean(title),
    current: title ? { id: "", title } : {},
  };
}

export function normalizeTextField(value) {
  if (value == null || typeof value === "object") return "";
  return String(value);
}
